import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ResponsiveDataManagement from "../../../Components/Common/ResponsiveManagementLayout";
import CustomerTypeService from "../../../services/OrderingServices/CustomerTypeService";
import CustomerTypeForm from "../component/CustomerTypeForm";
import DeleteModal from "../../../Components/Common/DeleteModal";
import {
  Card,
  CardBody,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import StatusBadge from "../../../Components/Common/Badge";
const CustomerType = () => {
  const [unitList, setUnitList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [openDropdownId, setOpenDropdownId] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  // Summary stats
  const [totalCustomerTypes, setTotalCustomerTypes] = useState(0);
  const [totalCustomers, setTotalCustomers] = useState(0);
  const [activeCustomerTypes, setActiveCustomerTypes] = useState(0);
  const [inactiveCustomerTypes, setInactiveCustomerTypes] = useState(0);
  const [statusFilter, setStatusFilter] = useState("");

  const navigate = useNavigate();

  const fetchUnitList = async () => {
    try {
      setLoading(true);
      const response = await CustomerTypeService.getList();
      setUnitList(response?.items || []);
      setTotalCustomerTypes(response.summary?.totalCustomerTypes || 0);
      setTotalCustomers(response.summary?.totalCustomers || 0);
      setActiveCustomerTypes(response.summary?.activeCustomerTypes || 0);
      setInactiveCustomerTypes(response.summary?.inactiveCustomerTypes || 0);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  useEffect(() => {
    fetchUnitList();
  }, []);

  const handleAdd = () => setAddModal(true);
  const handleEdit = (unit) => {
    setSelectedUnit(unit);
    setAddModal(true);
  };
  const handleDeleteClick = (unit) => {
    setSelectedUnit(unit);
    setDeleteModal(true);
  };
  const handleDelete = async () => {
    if (selectedUnit) {
      try {
        await CustomerTypeService.delete(selectedUnit.id || selectedUnit);
        setUnitList((prev) =>
          prev.filter((unit) => unit.id !== (selectedUnit.id || selectedUnit))
        );
        setDeleteModal(false);
        setSelectedUnit(null);
      } catch (error) {
        console.error(error);
      }
    }
  };

  const columns = [
    {
      name: "S.N",
      selector: (row, index) => (currentPage - 1) * perPage + index + 1,
      sortable: false,
      width: "75px",
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Description",
      selector: (row) => row.description,
    },
    {
      name: "Total Customers",
      selector: (row) => row.totalCustomers,
      sortable: true,
    },
    {
      name: "Status",
      cell: (row) => (
        // <span className={`badge ${row.isActive ? "bg-success" : "bg-danger"}`}>
        //   {row.isActive ? "Active" : "Inactive"}
        // </span>

        <StatusBadge status={row.isActive} type="status" pill={true} />
      ),
      sortable: true,
    },
    {
      name: "Discount (%)",
      selector: (row) => row.discountPercentage,
      sortable: true,
      right: true,
    },
  ];

  const stats = [
    {
      title: "Total Customer Types",
      value: totalCustomerTypes,
      color: "#0d6efd",
      icon: "bx bx-user",
    },
    {
      title: "Total Group Customers",
      value: totalCustomers,
      color: "#28a745",
      icon: "bx bx-purchase-tag",
    },
    {
      title: "Active Customer Types",
      value: activeCustomerTypes,
      color: "#17a2b8",
      icon: "bx bx-category",
    },
    {
      title: "Inactive Customer Types",
      value: inactiveCustomerTypes,
      color: "#ffc107",
      icon: "bx bx-block",
    },
  ];

  const filteredUnitList = unitList.filter((unit) => {
    if (!statusFilter) return true;
    return statusFilter === "active" ? unit.isActive : !unit.isActive;
  });

  const statusOptions = [
    // { value: "", label: "All Status" },
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
  ];

  const handleStatusFilterChange = (value) => {
    setStatusFilter(value);
  };

  return (
    <>
      <ResponsiveDataManagement
        title="Customer Types"
        pageTitle="User Management"
        mobileCardTitle="Customer Types List"
        data={filteredUnitList}
        columns={columns}
        stats={stats}
        searchKeys={["name", "description", "discountPercentage", "isActive"]}
        onAdd={handleAdd}
        onEdit={handleEdit}
        onSelect={handleStatusFilterChange} // dropdown change
        selectOptions={statusOptions}
        selectValue={statusFilter}
        selectPlaceholder="All Status"
        // onDelete={handleDeleteClick}
        // customActions={[
        //   {
        //     label: "Edit",
        //     icon: "ri-edit-line text-warning",
        //     onClick: handleEdit,
        //   },

        //   // { label: "Delete", icon: "ri-delete-bin-5-line text-danger", onClick: handleDeleteClick },
        // ]}
        mobileCardRenderer={(item) => (
          <div className="mb-3">
            <Card className="shadow-sm rounded-3 border-0 border-start border-4 border-success">
              <CardBody>
                <div className="d-flex justify-content-between align-items-start">
                  <div className="flex-grow-1">
                    <h6 className="fw-bold text-primary mb-1">{item.name}</h6>
                    <p className="mb-1 text-muted small">
                      {item.description || "-"}
                    </p>
                    <div className="d-flex gap-2 flex-wrap align-items-center">
                      <span
                        className={`badge ${
                          item.isActive ? "bg-success" : "bg-danger"
                        }`}
                      >
                        {item.isActive ? "Active" : "Inactive"}
                      </span>
                      {item.discountPercentage > 0 && (
                        <span className="badge bg-warning">
                          {item.discountPercentage}% Discount
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Mobile dropdown actions */}
                  <Dropdown
                    isOpen={openDropdownId === item.id}
                    toggle={() =>
                      setOpenDropdownId(
                        openDropdownId === item.id ? null : item.id
                      )
                    }
                    direction="down"
                  >
                    <DropdownToggle
                      color="light"
                      className="btn-sm rounded-circle shadow-sm"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <i className="ri-more-2-fill" />
                    </DropdownToggle>

                    <DropdownMenu end>
                      <DropdownItem
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEdit(item);
                          setOpenDropdownId(null);
                        }}
                      >
                        <i className="ri-edit-line me-2" />
                        Edit
                      </DropdownItem>

                      <DropdownItem
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteClick(item);
                          setOpenDropdownId(null);
                        }}
                      >
                        <i className="ri-delete-bin-line me-2" />
                        Delete
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </CardBody>
            </Card>
          </div>
        )}
        loading={loading}
        emptyStateMessage="No customer types found"
        onPaginationChange={({ page, perPage }) => {
          setCurrentPage(page);
          setPerPage(perPage);
        }}
      />

      <CustomerTypeForm
        modal={addModal}
        toggleModal={() => {
          setAddModal(false);
          setSelectedUnit(null);
        }}
        setUnitList={setUnitList}
        unitList={unitList}
        selectedUnit={selectedUnit}
        fetchUnit={fetchUnitList}
      />

      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={() => setDeleteModal(false)}
        selectedItem={selectedUnit}
      />
    </>
  );
};

export default CustomerType;
